module.exports = __webpack_public_path__ + "img/贡献1.e4a0f47c.png";